import { render, staticRenderFns } from "./SearchDDA.vue?vue&type=template&id=7fea9d4e&scoped=true"
import script from "./SearchDDA.vue?vue&type=script&lang=ts"
export * from "./SearchDDA.vue?vue&type=script&lang=ts"
import style0 from "./SearchDDA.vue?vue&type=style&index=0&id=7fea9d4e&prod&scoped=true&lang=css"
import style1 from "./SearchDDA.vue?vue&type=style&index=1&id=7fea9d4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fea9d4e",
  null
  
)

export default component.exports